import dayjs, {Dayjs} from "dayjs";

export class DEF {
    static readonly MAX_MINUTES_IN_MONTH = 44640;
    static readonly DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
    static readonly DATE_FORMAT = 'YYYY-MM-DD';

    static readonly POPUP_SHOWING_MANUAL_CLOSE = 0;
    static readonly POPUP_SHOWING_DEFAULT_TIME = 1000 * 3;
    static readonly POPUP_SHOWING_INFINITE_TIME = 1000 * 60 * 10;

    static readonly TIME_BEGINNING: Dayjs = dayjs('1900-01-01').startOf('day');
    static readonly TIME_END: Dayjs = dayjs('9999-12-31').endOf('day');

    static readonly DEFAULT_DATE_FROM: Dayjs = dayjs().subtract(3, 'month').startOf('month');
    static readonly DEFAULT_DATE_TO: Dayjs = dayjs().endOf('month');

}